import { render, staticRenderFns } from "./WmsServerMasterDataSummary.vue?vue&type=template&id=20d545b4"
import script from "./WmsServerMasterDataSummary.vue?vue&type=script&lang=js"
export * from "./WmsServerMasterDataSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports